import './userDates.css';
import TripDetailsSubHeading from '../../tripDetailsSubHeading/TripDetailsSubHeading';
import { getFormattedDateReverse } from '../../../utils/date';

const UserDates = ({ datesType, packData, packDates }) => {
    return (
        <div className='userDatesDiv'>
            <TripDetailsSubHeading text={'Dates'} />
            <div className='userDatesPoint'>
                <ul>
                    {packDates?.map((packDateItem) => {
                        return (
                            <li key={packDateItem.id} className='userDatesText'>
                                ➡️ {getFormattedDateReverse(packDateItem.startDate)}
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};

export default UserDates;
